import React, { useState } from "react";
import "./Login.css";
import logo from "../../assets/images/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { userLogin } from "../../Services/UserService";

const Login = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault(); // Prevent form submission

    if (!phoneNumber || phoneNumber.length !== 10) {
      setError("Please enter a valid 10-digit mobile number");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      // Add country code +91 to the phone number
      const fullPhoneNumber = `${phoneNumber}`;

      const response = await userLogin(fullPhoneNumber);

      if (response.status === true || response.statusCode === 200) {
        // Navigate to verify page on success with login response data
        navigate("/Verify", {
          state: {
            phoneNumber: response.data.phoneNumber,
            randomCode: response.data.randomCode
          }
        });
      } else {
        setError(response.message || "Login failed. Please try again.");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError(err.response?.data?.message || err.message || "An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handlePhoneNumberChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Only allow digits
    if (value.length <= 10) {
      setPhoneNumber(value);
      setError(null);
    }
  };

  return (
    <div className="login-container">
      <div className="header pb_88 d-flex align-items-center">
        <div className="logo-section d-flex align-items-center">
          <p className="fs_20 m-0 me-2">Welcome to</p>
          <img src={logo} alt="Refined Grains" className="logo" />
        </div>
      </div>
      <h1 className="title fs_55 fw_500">Log in</h1>
      <label className="label d-block mt_20 fs_24 fw_600 pb_42  pt_56 ">
        Enter your mobile number
      </label>

      <div className="mobile-input-wrapper pb_70 pt_38 ">
        <input
          type="text"
          placeholder="Mobile number"
          className="mobile-number-input pb_18 fs_16"
          value={phoneNumber}
          onChange={handlePhoneNumberChange}
          maxLength={10}
          disabled={loading}
        />
      </div>

      {error && (
        <div className="text-danger mb-3">
          <p>{error}</p>
        </div>
      )}

      <button
        type="button"
        className="submit-btn pt_70"
        onClick={handleLogin}
        disabled={loading || !phoneNumber}
        style={{
          cursor: loading || !phoneNumber ? 'not-allowed' : 'pointer',
          pointerEvents: loading || !phoneNumber ? 'none' : 'auto'
        }}
      >
        {loading ? "Loading..." : "continue"}
        <span className="arrow">➜</span>
      </button>
    </div>
  );
};

export default Login;
